import { MachineApprovalStatus } from '../../constants/machine/machine.constant';
import { IMachine } from '../../interfaces/Machine.interfaces';

export interface IOpenMarketProductForGetTitle {
  brandName: string;
  machine: IMachine;
  showPsOnPendingApproval?: boolean;
}

export const getOpenMarketProductTitle = ({
  brandName,
  machine,
  showPsOnPendingApproval,
}: IOpenMarketProductForGetTitle) => {
  if (!machine) {
    return '';
  }

  const { APPROVAL, PSWAITING } = MachineApprovalStatus;
  const isApproved = machine.approvalStatus === APPROVAL;
  const isPendingApproval = showPsOnPendingApproval && machine.approvalStatus === PSWAITING;
  const { machineType } = machine;
  const isMachineTypeCombine = machineType === 'combine';
  const isMachineTypeTransplanter = machineType === 'transplanter';

  const machineTypeName = isMachineTypeCombine ? '콤바인' : isMachineTypeTransplanter ? '이앙기' : '트랙터';
  const baseTitle = `${brandName} ${machine.model} ${machineTypeName}`;

  if (isApproved || isPendingApproval) {
    const specification =
      isMachineTypeCombine || isMachineTypeTransplanter ? machine.rowConfig : `${machine.engineOutputInPs}마력`;
    return `${baseTitle} (${specification})`;
  }

  return baseTitle;
};
